import React from 'react';
import { SUBMISSION_PERIODS } from '../submissions/periodFormat';

export function ReportSystemInfoTab({ systemData, setSystemData, loading, onSave, onGoToFields, onCancel, periodCounts = {} }) {
  const enabled = systemData.enabled_periods || [];
  const togglePeriod = (p) => {
    const next = enabled.includes(p) ? enabled.filter((x) => x !== p) : [...enabled, p];
    setSystemData({ ...systemData, enabled_periods: next });
  };

  return (
    <form
      className="modal-form"
      onSubmit={(e) => {
        e.preventDefault();
        onSave(systemData);
      }}
      noValidate
    >
      <div className="form-group">
        <label htmlFor="report-system-info-name">System Name *</label>
        <input
          id="report-system-info-name"
          type="text"
          required
          value={systemData.name}
          onChange={(e) => setSystemData({ ...systemData, name: e.target.value })}
          maxLength={100}
        />
      </div>
      <div className="form-group">
        <label htmlFor="report-system-info-description">Description</label>
        <textarea
          id="report-system-info-description"
          value={systemData.description}
          onChange={(e) => setSystemData({ ...systemData, description: e.target.value })}
          maxLength={500}
        />
      </div>
      <fieldset className="form-group report-periods">
        <legend>Enabled submission periods</legend>
        {SUBMISSION_PERIODS.map((p) => {
          const checked = enabled.includes(p);
          const removingWithData = !checked ? false : (periodCounts[p] || 0) > 0;
          return (
            <label key={p} htmlFor={`report-period-${p}`} className="report-period-row">
              <span className="report-period-name">{p}</span>
              <input id={`report-period-${p}`} type="checkbox" checked={checked} onChange={() => togglePeriod(p)} />
              {removingWithData && <span className="report-period-note">({periodCounts[p]} existing)</span>}
            </label>
          );
        })}
        {enabled.length === 0 && <small role="alert">Select at least one period.</small>}
        {SUBMISSION_PERIODS.some((p) => !enabled.includes(p) && (periodCounts[p] || 0) > 0) && (
          <small className="report-period-hint">Existing submissions in disabled periods are kept; no new ones can be created.</small>
        )}
      </fieldset>
      <div className="form-group">
        <label htmlFor="report-system-per-country" className="report-period-row">
          <span className="report-period-name">One report per country</span>
          <input
            id="report-system-per-country"
            type="checkbox"
            checked={!!systemData.per_country}
            onChange={(e) => setSystemData({ ...systemData, per_country: e.target.checked })}
          />
        </label>
        <small>Employees pick a country when starting a report; each country gets its own report per period.</small>
      </div>
      <div className="report-system-actions">
        <button type="submit" className="btn-primary" disabled={loading || enabled.length === 0}>
          Save System Info
        </button>
        <button type="button" className="btn-secondary" onClick={onGoToFields} disabled={loading}>
          Go to Fields →
        </button>
        <button type="button" className="btn-secondary" onClick={onCancel} disabled={loading}>
          Cancel
        </button>
      </div>
    </form>
  );
}
